@if (wrapper && wrapper.isReady) {
  <div [formGroup]="wrapper.form" [class]="getFormGroupClass()">
    <acc-form-label [name]="name" [wrapper]="wrapper" [size]="config.size">
      @if (config.showCopyClipboard && currentValue && (isViewOnly() || isDisabled())) {
        <acc-copy-clipboard [content]="currentValue"/>
      }
    </acc-form-label>
    <div class="input-group">
      <input #input [type]="type" class="form-control" [class]="getClass()"
             [id]="name"
             [formControlName]="name"
             [placeholder]="getPlaceholder()"
             [step]="integer ? 1 : null"
             [attr.inputmode]="integer ? 'numeric' : null"
             (change)="onInputChange($event)"
             (keydown.enter)="onInputChange($event)"
             (keydown.tab)="onInputChange($event)"
             (keyup)="onInputKeyEvent($event)"
             [class.is-invalid]="isInvalid()"
             [class.disabled]="isViewOnly()">
      <ng-content/>
    </div>
    <acc-form-field-error [name]="name" [wrapper]="wrapper"/>
  </div>
}
